import { type ReactNode, useId } from 'react';

import HStack from '@/components/Layout/HStack';
import { cn } from '@/lib/cn';

import { CHART_AREA_MARGIN_LEFT, CHART_PRIMARY_COLOR } from './constants';

export function CompoundChartLegend(props: {
  monthlyValueLabel?: ReactNode;
  forecastedValueLabel?: ReactNode;
  cumulativeValueLabel?: ReactNode;
  forecastedCumulativeValueLabel?: ReactNode;
}) {
  const SLASH_PATTERN_ID = useId();

  return (
    <div
      className="flex flex-wrap gap-x-6 gap-y-2 w-full overflow-hidden"
      style={{
        paddingLeft: CHART_AREA_MARGIN_LEFT,
        maxWidth: '100%',
      }}
    >
      {props.monthlyValueLabel && (
        <HStack className="items-center gap-1.5 min-w-0 shrink-0 max-w-full">
          <svg width={12} height={12} className="rounded-[3px] shrink-0">
            <line
              x1="0"
              y1="6"
              x2="12"
              y2="6"
              stroke={CHART_PRIMARY_COLOR}
              strokeWidth="2"
            />
          </svg>
          <span className={cn('text-labelSmallReg truncate')}>
            {props.monthlyValueLabel}
          </span>
        </HStack>
      )}
      {props.forecastedValueLabel && (
        <HStack className="items-center gap-1.5 min-w-0 shrink-0 max-w-full">
          <svg width={12} height={12} className="rounded-[3px] shrink-0">
            <line
              x1="0"
              y1="6"
              x2="12"
              y2="6"
              stroke={CHART_PRIMARY_COLOR}
              strokeWidth="2"
              strokeDasharray="2, 2"
            />
          </svg>
          <span className={cn('text-labelSmallReg truncate')}>
            {props.forecastedValueLabel}
          </span>
        </HStack>
      )}
      {props.cumulativeValueLabel && (
        <HStack className="items-center gap-1.5 min-w-0 shrink-0 max-w-full">
          <svg width={12} height={12} className="rounded-[3px] shrink-0">
            <rect width="12" height="12" fill={CHART_PRIMARY_COLOR} />
          </svg>
          <span className={cn('text-labelSmallReg truncate')}>
            {props.cumulativeValueLabel}
          </span>
        </HStack>
      )}
      {props.forecastedCumulativeValueLabel && (
        <HStack className="items-center gap-1.5 min-w-0 shrink-0 max-w-full">
          <svg width={12} height={12} className="rounded-[3px] shrink-0">
            <defs>
              <pattern
                id={SLASH_PATTERN_ID}
                width="3"
                height="3"
                patternUnits="userSpaceOnUse"
                patternTransform="rotate(75)"
              >
                <line
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="3"
                  stroke={CHART_PRIMARY_COLOR}
                  strokeWidth={2}
                />
              </pattern>
            </defs>
            <rect width="12" height="12" fill={`url(#${SLASH_PATTERN_ID})`} />
          </svg>
          <span className={cn('text-labelSmallReg truncate')}>
            {props.forecastedCumulativeValueLabel}
          </span>
        </HStack>
      )}
    </div>
  );
}
